<template>
  <div :class="isShowBatchBtns ? 'padding' : ''">
    <div class="page-container" v-if="!showDownloadCenter">
      <div class="page_title">
        <div class="page_title_desc">运费结算审核管理</div>
        <kt-button
          icon=""
          label="下载中心"
          perms="-1"
          type="text"
          size="medium"
          @click="toDownloadCenter"
        />
      </div>
      <el-divider></el-divider>
      <!--工具栏-->
      <div class="toolbar">
        <el-form :inline="true" :model="filterForm" size="small">
          <el-form-item label="">
            <el-input
              v-model="filterForm.driverName"
              placeholder="司机姓名"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="filterForm.carPlateNo"
              placeholder="车牌号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="filterForm.driverPhone"
              placeholder="手机号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="filterForm.waybillNo"
              placeholder="运单编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="filterForm.bookingOrderNo"
              placeholder="预约单编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label>
            <el-date-picker
              v-model="filterForm.outMineTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="出矿开始时间"
              end-placeholder="出矿结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label>
            <el-date-picker
              v-model="filterForm.outStationTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="出站开始时间"
              end-placeholder="出站结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label>
            <el-date-picker
              v-model="filterForm.payTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="付款开始时间"
              end-placeholder="付款结束时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="filterForm.lybOwnerUid"
              filterable
              clearable
              placeholder="请输入发运主体"
            >
              <el-option
                v-for="item in shippingSubjectList"
                :key="item.codeStr"
                :label="item.name"
                :value="item.codeStr"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filterForm.loadingAddress"
              clearable
              placeholder="装货地名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="filterForm.unloadingAddress"
              clearable
              placeholder="卸货地名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select
              v-model="filterForm.settleStatus"
              clearable
              placeholder="运费结算状态"
              @change="changeSettleStatus"
            >
              <el-option
                v-for="item in settleStatusList"
                :key="item.codeStr"
                :label="item.name"
                :value="item.codeStr"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label>
            <el-select
              v-model="filterForm.waybillStatus"
              clearable
              placeholder="运单当前状态"
            >
              <el-option
                v-for="item in waybillStatusList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label>
            <el-date-picker
              v-model="filterForm.billTime"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="票据时间"
              end-placeholder="票据时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filterForm.unloadingDataUploadWay" filterable placeholder="卸货数据上传方式" clearable>
              <el-option v-for="item in uploadTypeList" :key="item.code" :label="item.name" :value="item.code"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-search"
              label="搜索"
              perms="-1"
              type="primary"
              @click="handleSearch"
            />
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-share"
              label="重置"
              perms="-1"
              @click="handleReset"
              type="primary"
            />
          </el-form-item>
          <el-form-item>
            <kt-button
              icon="fa fa-sign-out"
              label="导出"
              perms="60520"
              type="primary"
              @click="showExportDialog = true"
            />
          </el-form-item>
        </el-form>
      </div>
      <!--表格树内容栏-->
      <el-table
        :data="waybillList"
        stripe
        size="mini"
        style="width: 100%"
        row-key="flowNo"
        ref="table"
      >
        <el-table-column align="center" fixed width="55" v-if="isShowBatchBtns">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row['checked']"
              @change="(val) => handleSingleSelect(scope.row, val)"
            ></el-checkbox>
          </template>
        </el-table-column>
        <el-table-column
          type="index"
          width="50"
          align="center"
          fixed
          label="序号"
        ></el-table-column>
        <el-table-column
          prop="waybillNo"
          align="center"
          width="240"
          label="运单编号"
        >
          <template slot-scope="scope">
            <span
              class="waybillbo-style"
              @click="handleToDetail(scope.row, 'waybillDetail')"
              >{{ scope.row.waybillNo }}</span
            >
            <p>{{ scope.row.bookingNo }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" width="240" label="司车信息">
          <template slot-scope="scope">
            <p>{{ scope.row.carPlateNo }}</p>
            <p>{{ scope.row.driverName }}</p>
            <p>{{ scope.row.driverPhone }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="装卸地点">
          <template slot-scope="scope">
            <p>装：{{ scope.row.loadingAddress }}</p>
            <p>卸：{{ scope.row.unloadingAddress }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" label="运费信息">
          <template slot-scope="scope">
            <p v-if="scope.row.carriagePrice">
              运价:{{ scope.row.carriagePrice }}元/吨<kt-button
                v-if="judgeUpdate(scope.row)"
                icon="el-icon-edit"
                label=""
                type="text"
                perms="60523"
                @click="showUpdatePrice('carriageUnitPrice', scope.row)"
              ></kt-button>
            </p>
            <p v-if="scope.row.loadingTon">
              装货吨位:{{ scope.row.loadingTon }}吨<kt-button
                v-if="judgeUpdate(scope.row)"
                icon="el-icon-edit"
                type="text"
                label=""
                perms="60523"
                @click="showUpdatePrice('loadingTon', scope.row)"
              ></kt-button>
            </p>
            <p v-if="scope.row.unloadingTon">
              卸货吨位:{{ scope.row.unloadingTon }}吨<kt-button
                v-if="judgeUpdate(scope.row)"
                icon="el-icon-edit"
                type="text"
                perms="60523"
                label=""
                @click="showUpdatePrice('unloadingTon', scope.row)"
              ></kt-button>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="120"
          prop="settleStatusDesc"
          label="运费结算状态"
        >
        </el-table-column>
        <el-table-column align="center" label="发运主体" prop="dispatchSubject">
          <!-- <template slot-scope="scope">
             {{
              scope.row.dispatchSubjectNo
                ? shippingSubjectList.find(
                    (item) => item.codeStr === scope.row.dispatchSubjectNo
                  )["name"]
                : ""
            }} 
          </template> -->
        </el-table-column>
        <el-table-column align="center" width="80" label="操作">
          <template slot-scope="scope">
            <!-- <div class="btns"> -->
            <el-row
              ><kt-button
                label="详情"
                perms="-1"
                type="text"
                @click="handleToDetail(scope.row, 'settleDetail')"
            /></el-row>
            <el-row
              ><kt-button
                v-if="scope.row.settleStatus === 15 || scope.row.settleStatus === 40"
                label="审核"
                perms="60521"
                type="text"
                @click="showAuditDialog(scope.row, 'audit')"
            /></el-row>
            <el-row
              ><kt-button
                v-if="
                  scope.row.settleStatus === 5 ||
                  scope.row.settleStatus === 15 ||
                  scope.row.settleStatus === 10 ||
                  scope.row.settleStatus === 40 ||
                  scope.row.settleStatus === 35
                "
                label="取消结算"
                perms="60522"
                type="text"
                @click="showAuditDialog(scope.row, 'cancel')"
            /></el-row>
            <!-- </div> -->
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="flex">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="totalSize"
          style="padding: 20px"
        ></el-pagination>
      </div>
      <!-- 导出弹窗 本来打算做公共的 先各走各的 -->
      <el-dialog
        title="提示"
        center
        :visible.sync="showExportDialog"
        :close-on-click-modal="false"
        width="400px"
      >
        <div style="text-align: center">
          <span>请确认是否导出？</span>
          <br />
          <span>导出的数据请在下载中心内进行下载</span>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="showExportDialog = false"
            >取 消</el-button
          >
          <el-button size="mini" type="primary" @click="newExportData"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 运费修改弹窗 -->
      <el-dialog
        :title="updateFeeTitle"
        :visible.sync="isShowUpdateFee"
        v-if="isShowUpdateFee"
        :lock-scroll="true"
        :close-on-click-modal="false"
        width="400px"
        @close="clearUpdateFee"
      >
        <el-form
          :model="updateForm"
          label-width="100px"
          size="mini"
          ref="updateForm"
          :rules="updateRulesForm"
        >
          <el-form-item :label="feeEnum[updateFeeType] + '：'" prop="updateFee">
            <el-input
              style="width: 180px"
              v-model="updateForm.updateFee"
              clearable
              :maxlength="8"
              :placeholder="`请输入修改后的${feeEnum[updateFeeType]}`"
              type="number"
            ></el-input
            >{{ updateFeeType === "carriageUnitPrice" ? "元/吨" : "吨" }}
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="mini" @click="isShowUpdateFee = false"
            >取 消</el-button
          >
          <el-button size="mini" type="primary" @click="submitUpdateFee"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- 审核弹窗 -->
      <el-dialog
        title="审核"
        v-if="isShowAuditDialog"
        :visible.sync="isShowAuditDialog"
        :lock-scroll="true"
        :close-on-click-modal="false"
        width="300px"
        @close="clearCurWaybill"
      >
        <div class="audit-content">
          <div class="item-info">
            <span>车牌号：</span>
            <span>{{ curWaybill.carPlateNo }}</span>
          </div>
          <div class="item-info">
            <span>运价(元/吨)：</span>
            <span>{{ curWaybill.carriageUnitPrice }}</span>
          </div>
          <div class="item-info">
            <span>装货吨位(吨)：</span>
            <span>{{ curWaybill.loadingTon }}</span>
          </div>
          <div class="item-info">
            <span>卸货吨位(吨)：</span>
            <span>{{ curWaybill.unloadingTon }}</span>
          </div>
          <div class="item-info">
            <span>煤种单价(元/吨)：</span>
            <span>{{ curWaybill.coalCategoryUnitPrice }}</span>
          </div>
          <div class="item-info">
            <span>允许货损(KG)：</span>
            <span>{{ curWaybill.allowGoodsDamage }}</span>
          </div>
          <div class="item-info">
            <span>装货费用(元)：</span>
            <span>{{ curWaybill.loadingFee }}</span>
          </div>
          <div class="item-info">
            <span>卸货费用(元)：</span>
            <span>{{ curWaybill.unloadingFee }}</span>
          </div>
          <div class="item-info">
            <span>核算吨位方式：</span>
            <span>{{ tonSettleType[curWaybill.tonSettleType] }}</span>
          </div>
          <div class="item-info">
            <span>抹零方式：</span>
            <span>{{
              curWaybill.roundType
                ? roundTypeList.find((item) => {
                    return item.codeStr == curWaybill.roundType;
                  })["name"]
                : ""
            }}</span>
          </div>
          <div class="item-info">
            <span>手动扣/补款金额(元)：</span>
            <span>{{ curWaybill.manualModifyPrice }}</span>
          </div>
          <br />
          <div class="item-info">
            <span>建议运费(元)：</span>
            <span style="color: red">{{ curWaybill.suggestCarriage }}</span>
          </div>
        </div>
        <span slot="footer">
          <el-button size="mini" @click="accessAudit" type="primary"
            >审核通过</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="isShowRejectDialog = true"
            >审核驳回</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="审核驳回"
        :lock-scroll="true"
        :visible.sync="isShowRejectDialog"
        :close-on-click-modal="false"
        width="600px"
        @close="clearRejectForm"
      >
        <el-form label-width="100px" size="mini" :model="rejectForm">
          <el-form-item label="驳回原因：">
            <el-radio-group
              v-model="rejectForm.reason"
              @change="changeReason"
              style="margin-top: 10px"
            >
              <el-radio label="装货信息错误"></el-radio>
              <el-radio label="卸货信息错误"></el-radio>
              <el-radio label="装货、卸货信息错误"></el-radio>
              <el-radio label="其他">
                其他
                <el-input
                  v-model="rejectForm.otherReason"
                  size="mini"
                  maxlength="20"
                  placeholder="请输入原因"
                  :disabled="isDisabled"
                  clearable
                ></el-input>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="mini" @click="clearRejectForm"
            >取 消</el-button
          >
          <el-button size="mini" type="primary" @click="rejection"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="取消结算"
        :lock-scroll="true"
        :visible.sync="isShowCancelSettle"
        :close-on-click-modal="false"
        width="400px"
        @close="clearCancelForm"
      >
        <el-form :model="cancelForm" label-width="100px" size="mini">
          <el-form-item label="取消原因：">
            <el-input
              type="textarea"
              v-model="cancelForm.cancelReason"
              placeholder="请输入取消原因"
              show-word-limit
              :maxlength="20"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="mini" @click="isShowCancelSettle = false"
            >取 消</el-button
          >
          <el-button size="mini" type="primary" @click="cancelSettle"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-dialog
        title="提示"
        :lock-scroll="true"
        :visible.sync="isShowBatchDialog"
        v-if="isShowBatchDialog"
        :close-on-click-modal="false"
        width="600px"
        center
        @close="clearRejectForm"
      >
        <div class="tips">
          <span>
            {{
              `当前选中共计${
                checkedWaybills.length
              }单运单结算，合计装货吨位${computedLoadingTonSum}吨，卸货吨位${computedUnloadingTonSum}吨，请确认是否全部审核${
                action == "batchAuditUnPass" ? "驳回" : "通过"
              }？`
            }}
          </span>
        </div>
        <el-form
          label-width="100px"
          size="mini"
          :model="rejectForm"
          v-if="action === 'batchAuditUnPass'"
        >
          <el-form-item label="驳回原因：">
            <el-radio-group
              v-model="rejectForm.reason"
              @change="changeReason"
              style="margin-top: 10px"
            >
              <el-radio label="装货信息错误"></el-radio>
              <el-radio label="卸货信息错误"></el-radio>
              <el-radio label="装货、卸货信息错误"></el-radio>
              <el-radio label="其他">
                其他
                <el-input
                  v-model="rejectForm.otherReason"
                  style="width: 150px"
                  size="mini"
                  maxlength="20"
                  placeholder="请输入原因"
                  :disabled="isDisabled"
                  clearable
                ></el-input>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button size="mini" @click="clearRejectForm"
            >取 消</el-button
          >
          <el-button size="mini" type="primary" @click="handleBatchOperation"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
    <audit-download-center
      v-if="showDownloadCenter"
      @Adjust="AdjustFun"
    ></audit-download-center>
    <!-- 批量操作组件 -->
    <div class="bottom-info" v-if="isShowBatchBtns">
      <div class="left-item">
        <el-checkbox
          v-model="checkCurPage"
          @change="handleCheckCurPage"
          :indeterminate="isIndeterminate"
          >选中当前页</el-checkbox
        >
        <el-checkbox v-model="checkAll" @change="handleCheckAll"
          >选中所有</el-checkbox
        >
      </div>
      <div class="center-item">
        <span
          >当前选中共计{{
            checkAll ? totalSize : checkedWaybills.length
          }}单</span
        >
        <span>装货吨位共计{{ computedLoadingTonSum }}吨</span>
        <span>卸货吨位共计{{ computedUnloadingTonSum }}吨</span>
      </div>
      <div class="right-item">
        <el-button
          type="primary"
          size="small"
          :disabled="!!!checkedWaybills.length"
          @click="showBatchOperation('batchAuditPass')"
          >批量审核通过</el-button
        >
        <el-button
          type="primary"
          size="small"
          :disabled="!!!checkedWaybills.length"
          @click="showBatchOperation('batchAuditUnPass')"
          >批量审核驳回</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
import AuditDownloadCenter from "./AuditDownloadCenter.vue";
import global from '@/utils/global.js'
import {feeEnum, tonSettleType ,settleTypeList ,ownerList ,uploadTypeList} from '@/utils/instance.js'

export default {
  data() {
    return {
      showDownloadCenter: false,
      pageSize: 10,
      pageNo: 1,
      waybillList: [],
      filterForm: {},
      shippingSubjectList:ownerList,
      showExportDialog: false,
      totalSize: 0,
      isShowUpdateFee: false,
      updateFeeType: "",
      updateFeeTitle: "",
      feeEnum,
      settleTypeList,
      settleStatusList: [],
      updateForm: {
        updateFee: 0,
      },
      uploadTypeList,
      curWaybill: {},
      isShowAuditDialog: false,
      isShowRejectDialog: false,
      rejectForm: {
        reason: [],
        otherReason: "",
      },
      tonSettleType,
      isDisabled: true,
      isShowCancelSettle: false,
      cancelForm: {
        cancelReason: "",
      },
      roundTypeList: [],
      // waybillStatusList: [],
      updateRulesForm: {
        updateFee: [{ required: true, validator: this.checkUpdateFee() }],
      },
      checkCurPage: false,
      checkedWaybills: [],
      isShowBatchBtns: false,
      checkAll: false,
      isIndeterminate: false,
      action: "",
      isShowBatchDialog: false,
    };
  },
  components: {
    KtButton,
    AuditDownloadCenter,
  },
  mounted() {
    if(global.mode === 'develop'){
      this.getShippingList();
    }
    /* ie不支持 */
    const channel = new BroadcastChannel('update-child-info')
    channel.addEventListener('message',(e) => {
      this.getWaybillList();
    })
    this.getSettleStatusList();
    this.getWaybillList();
    // this.getWaybillNoStatus();
    this.getRoundTypeList();
  },
  methods: {
    handleSearch() {
      this.pageNo = 1;
      this.isIndeterminate = false;
      this.checkedWaybills= [];
      this.checkAll = false;
      this.checkCurPage = false;
      this.getWaybillList();
    },
    async getRoundTypeList() {
      let result = await this.$api.apply.mGetRoundTypeList();
      result.data.forEach((item) => {
        item.codeStr = Number(item.codeStr);
      });
      this.roundTypeList = result.data;
    },
    // getWaybillNoStatus() {
    //   this.$api.waybill.mGetAllStatusList().then((res) => {
    //     if (res.data && res.data.length > 0) {
    //       this.waybillStatusList = res.data.filter((item) => {
    //         return item.code != 16;
    //       });
    //     } else {
    //       this.waybillStatusList = [];
    //     }
    //   });
    // },

    getSettleStatusList() {
      this.$api.finance.mGetSettleStatusList({}).then((res) => {
        this.settleStatusList = res.data;
      });
    },
    handleToDetail(row, type) {
      let url = `${location.origin}${
        type === "waybillDetail" ? "/waybill/detail?id=" : "/finance/detail?id="
      }${row.waybillNo}`;
      window.open(url);
    },
    handleReset() {
      (this.filterForm = {}), this.handleSearch();
    },
    refreshPageRequest(val) {
      this.pageNo = val;
      this.getWaybillList();
    },
    toDownloadCenter() {
      this.showDownloadCenter = true;
    },
    getShippingList() {
      this.$api.finance.mGetOwnerList({}).then((res) => {
        this.shippingSubjectList = res.data;
      });
    },
    async getWaybillList() {
      const loading = this.$loading()
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      let index = 0;
      let form = { ...this.filterForm };
      this.isShowBatchBtns = form.settleStatus == 15;
      for (const key in form) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (
            key === "outMineTime" ||
            key === "outStationTime" ||
            key === "payTime" ||
            key === 'billTime'
          ) {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.finance.mGetAuditList(params);
      loading.close()
      this.totalSize = res.data.totalSize;
      let data = [];
      res.data.dtoList &&
        res.data.dtoList.map((item) => {
          data.push({
            checked: this.checkAll,
            ...item,
          });
        });

      this.waybillList = this.isShowBatchBtns ? data : res.data.dtoList || [];
      this.judgeCheckedStatus();
    },
    newExportData() {
      let params = {
        pageNo: this.pageNo,
        pageSize: 100000,
      };
      let index = 0;
      let form = { ...this.filterForm };
      for (const key in form) {
        const val = this.filterForm[key];
        if (val && val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (
            key === "outMineTime" ||
            key === "outStationTime" ||
            key === "payTime" ||
            key === 'billTime'
          ) {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      this.$api.finance.settleExport(params).then((res) => {
        this.$message({
          type: "success",
          offset: 300,
          message: "成功创建下载任务，请稍后在下载中心内进行下载",
        });
        this.showExportDialog = false;
      });
    },
    AdjustFun(val) {
      this.showDownloadCenter = !val;
    },
    clearUpdateFee() {
      this.updateForm.updateFee = null;
      this.curWaybill = {};
    },
    //运费信息修改
    showUpdatePrice(type, row) {
      this.updateFeeType = type;
      this.updateFeeTitle = this.feeEnum[type] + "修改";
      this.updateForm.updateFee =
        type === "carriageUnitPrice"
          ? row["carriagePrice"] + ""
          : +row[type] + "";
      this.curWaybill = row;
      this.isShowUpdateFee = true;
    },
    checkUpdateFee() {
      return (rule, value, callback) => {
        let type = this.updateFeeType;
        if (!value) {
          return callback(`请输入${this.feeEnum[type]}`);
        }
        if (value < 0 || value == 0) {
          return callback(new Error("请输入大于0的数字"));
        }
        this.updateForm.updateFee = value.match(/^\d*(\.?\d{0,2})/g)[0];
        return callback();
      };
    },
    // 提交修改运费
    submitUpdateFee() {
      this.$refs.updateForm.validate((valid) => {
        if (valid) {
          this.$api.finance
            .updateBaseInfo({
              waybillNo: this.curWaybill.waybillNo,
              [this.updateFeeType]: this.updateForm.updateFee,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "修改成功",
                offset: 300,
              });
              this.isShowUpdateFee = false;
              this.getWaybillList();
            });
        }
      });
    },
    async showAuditDialog(row, type) {
      if (type === "audit") {
        let res = await this.$api.finance.mGetApprovalDetail({
          waybillNo: row.waybillNo,
        });
        this.curWaybill = res.data;
        this.isShowAuditDialog = true;
      } else {
        this.curWaybill = row;
        this.isShowCancelSettle = true;
      }
    },
    clearCurWaybill() {
      this.curWaybill = {};
    },
    accessAudit() {
      this.$api.finance
        .approvalPass({
          waybillNo: this.curWaybill.waybillNo,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "操作成功",
            offset: 300,
          });
          this.isShowAuditDialog = false;
          this.checkCurPage = false;
          this.checkAll = false;
          this.checkedWaybills=[] ;
          this.isIndeterminate = false;
          this.curWaybill = {};
          this.getWaybillList();
        });
    },
    changeReason(val) {
      if (!val.length) return;
      this.isDisabled = val.includes("其他") ? false : true;
      if (!val.includes("其他")) {
        this.rejectForm.otherReason = "";
      }
    },
    clearRejectForm() {
      this.isShowRejectDialog = false
      this.isShowBatchDialog = false
      this.rejectForm.reason = [];
      this.rejectForm.otherReason = "";
      this.action = ''
    },
    rejection() {
      let { reason, otherReason } = this.rejectForm;
      if (!reason.length) {
        this.$message({
          type: "error",
          message: "请选择原因",
          offset: 300,
        });
        return;
      }
      if (reason.includes("其他") && otherReason == "") {
        this.$message({
          type: "error",
          message: "请填写原因",
          offset: 300,
        });
        return;
      }
      let rejectReason = reason.replace("其他", otherReason);
      this.$api.finance["approvalUnPass"]({
        waybillNo: this.curWaybill.waybillNo,
        upPassReason: rejectReason,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "驳回成功",
          offset: 300,
        });
        this.curWaybill = {};
        this.isDisabled = true;
        this.checkedWaybills = [];
        this.checkAll = false;
        this.checkCurPage = false;
        this.isIndeterminate = false;
        this.isShowRejectDialog = false;
        this.isShowAuditDialog = false;
        this.getWaybillList();
      });
    },
    //取消结算
    cancelSettle() {
      if (!this.cancelForm.cancelReason) {
        this.$message({
          type: "error",
          message: "请输入取消原因",
          offset: 300,
        });
        return;
      }
      this.$api.finance
        .cancelSettle({
          upPassReason: this.cancelForm.cancelReason,
          waybillNo: this.curWaybill.waybillNo,
        })
        .then((res) => {
          this.$message({
            type: "success",
            message: "取消结算成功",
            offset: 300,
          });
          this.isShowCancelSettle = false;
          this.curWaybill = {};
          this.checkedWaybills = [];
          this.checkAll = false;
          this.checkCurPage = false;
          this.getWaybillList();
        });
    },
    clearCancelForm() {
      this.cancelForm.cancelReason = "";
      this.curWaybill = {};
    },
    handleCheckCurPage(val) {
      this.waybillList.forEach((item) => {
        item.checked = val;
      });
      this.isIndeterminate = false;
      if (!val) {
        this.waybillList.map((item) => {
          this.checkedWaybills.map((i, index) => {
            if (i.waybillNo === item.waybillNo) {
              this.checkedWaybills.splice(index, 1);
            }
          });
        });
        this.checkAll = false;
      } else {
        this.waybillList.forEach((item) => {
          let info = this.checkedWaybills.find((i) => {
            return i.waybillNo == item.waybillNo;
          });
          if (!info) this.checkedWaybills.push({ waybillNo: item.waybillNo, loadingTon:item.loadingTon , unloadingTon:item.unloadingTon });
        });
        this.checkAll = this.checkedWaybills.length == this.totalSize;
      }
    },
    handleSingleSelect(row, val) {
      if (val) {
        this.checkedWaybills.push({waybillNo:row.waybillNo,loadingTon:row.loadingTon , unloadingTon:row.unloadingTon});
        let checkCurPage = this.waybillList.every((item) => {
          return this.checkedWaybills.find((i) => {
            return item.waybillNo === i.waybillNo;
          });
        });
        this.checkCurPage = checkCurPage;
        this.isIndeterminate = !checkCurPage;
      } else {
        this.checkCurPage = false;
        this.checkAll = false;
        this.checkedWaybills.forEach((item, index) => {
          if (item.waybillNo === row.waybillNo) {
            this.checkedWaybills.splice(index, 1);
          }
        });
        this.isIndeterminate = !!this.checkedWaybills.length;
      }
      this.checkAll = this.checkedWaybills.length == this.totalSize;
    },
    showBatchOperation(action) {
      this.isShowBatchDialog = true;
      this.action = action;
      // this.$confirm(
      //   `当前选中共计${this.checkedWaybills.length}单运单结算，合计装货吨位${this.computedLoadingTonSum}吨，卸货吨位${this.computedUnloadingTonSum}吨，请确认是否全部审核${action=='batchAuditUnPass'?'驳回':'通过'}？`,
      //   "提示",
      //   {
      //     type: "info",
      //   }
      // ).then(async (confirm) => {
      //   let arr = [];
      //   this.action =  action
      //   this.checkedWaybills.forEach((item) => {
      //     arr.push(item.waybillNo);
      //   });
      //   let res = await this.$api.finance[action]({
      //     waybillNo: arr.join(","),
      //   });
      //   this.$message({
      //     type: "success",
      //     message: "批量审核成功",
      //     offset: 300,
      //   });
      //   this.checkCurPage = false;
      //   this.checkAll = false;
      //   this.checkedWaybills.length = 0;
      //   this.getWaybillList();
      //   return;
      // });
    },
    async handleBatchOperation() {
      let arr = [];
      let action = this.action;
      this.checkedWaybills.forEach((item) => {
        arr.push(item.waybillNo);
      });
      let params = {
        waybillNo: arr.join(","),
      };
      if (action === "batchAuditUnPass") {
        let { reason, otherReason } = this.rejectForm;
        if (!reason.length) {
          this.$message({
            type: "error",
            message: "请选择原因",
            offset: 300,
          });
          return;
        }
        if (reason.includes("其他") && otherReason == "") {
          this.$message({
            type: "error",
            message: "请填写原因",
            offset: 300,
          });
          return;
        }
        let rejectReason = reason.replace("其他", otherReason);
        params.upPassReason = rejectReason;
      }
      const loading = this.$loading()
      let res = await this.$api.finance[action](params);
      loading.close()
      this.$message({
        type: "success",
        message: `批量${action==='batchAuditPass' ? '通过' :'驳回'}成功`,
        offset: 300,
      });
      this.action = ''
      this.checkCurPage = false;
      this.checkAll = false;
      this.checkedWaybills = [];
      this.isShowBatchDialog =  false
      this.getWaybillList();
    },
    async handleCheckAll(val) {
      this.checkCurPage = val;
      this.handleCheckCurPage(val)
      this.checkAll = val
      this.checkedWaybills = [];
      if (val) {
        if(!this.waybillList.length) return
        let params = {
          pageNo: 1,
          pageSize: this.totalSize,
        };
        let form = { ...this.filterForm };
        let index = 0;
        for (const key in form) {
          const val = this.filterForm[key];
          if (val && val !== "") {
            params["searchFieldList[" + index + "].fieldName"] = key;
            if (
              key === "outMineTime" ||
              key === "outStationTime" ||
              key === "payTime"||
              key === "billTime"
            ) {
              params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
              params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
            } else {
              params["searchFieldList[" + index + "].singleValue"] = val;
            }
            index++;
          }
        }
        let res = await this.$api.finance.mGetAuditList(params);
        res.data.dtoList && res.data.dtoList.forEach(item=>{
          this.checkedWaybills.push({waybillNo:item.waybillNo , loadingTon:item.loadingTon , unloadingTon:item.unloadingTon})
        })
      }
    },
    changeSettleStatus(val) {
      if (!val) {
        this.checkCurPage = false;
        this.checkAll = false;
        this.checkedWaybills.length = 0;
        this.isShowBatchBtns = false;
      }
    },
    judgeCheckedStatus() {
      if (!this.checkAll) {
        this.waybillList.forEach((item) => {
          let info = this.checkedWaybills.find((i) => {
            return i.waybillNo == item.waybillNo;
          });
          item.checked = !!info;
        });
        this.checkCurPage = this.waybillList.length
          ? this.waybillList.every((item) => {
              return item.checked;
            })
          : false;
        this.isIndeterminate = this.checkedWaybills.length
          ? !this.checkCurPage
          : false;
      } else {
        this.waybillList.forEach((item) => {
          let info = this.checkedWaybills.find((i) => {
            return i.waybillNo == item.waybillNo;
          });
          if (!info) this.checkedWaybills.push({waybillNo:item.waybillNo,loadingTon:item.loadingTon,unloadingTon:item.unloadingTon });
        });
      }
    },
  },

  computed: {
    judgeUpdate() {
      return (row) => {
        let arr = [5, 10, 15, 35];
        return row.settleStatus ? arr.includes(row.settleStatus) : false;
      };
    },
    computedLoadingTonSum() {
      let arr = this.checkedWaybills,
        loadingTonSum = 0;
      arr.forEach((item) => {
        loadingTonSum += item.loadingTon;
      });
      return loadingTonSum ? loadingTonSum.toFixed(2) : 0;
    },
    computedUnloadingTonSum() {
      let arr = this.checkedWaybills,
        unloadingTonSum = 0;
      arr.forEach((item) => {
        unloadingTonSum += item.unloadingTon;
      });
      return unloadingTonSum ? unloadingTonSum.toFixed(2) : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.waybillbo-style {
  cursor: pointer;
  color: #409eff;
}
.btns {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.audit-content {
  width: 100%;
  .item-info {
    width: 100%;
    display: flex;
    align-items: center;
  }
}
// ::v-deep .el-button {
//   margin: 0;
// }

.flex {
  width: 100%;
  text-align: right;
}
.bottom-info {
  width: 100%;
  height: 80px;
  padding-right: 200px;
  box-sizing: border-box;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-around;
  bottom: 0;
  background: #eee;
  z-index: 999;
  .left-item {
    display: flex;
    justify-content: center;
  }
  .center-item {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    font-weight: bold;
    span {
      margin: 0 10px;
    }
  }
}
.padding {
  padding-bottom: 80px;
}
.tips {
  text-indent: 2em;
  font: 16px;
}
</style>